import _ from 'lodash'
import React, { Component } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import { connect } from 'react-redux'
import { updateCalculator, updateComponentList, displayVariations } from '../../../actions/calculator'
import Tab from '../../Calculator/Tabs/Tab'
import Configurator from '../../Calculator/Configurator'
import Button from '../../UI/Button'
import { Wrapper, Caret } from './Step0'
import { getNetPrice, getTax } from '../../../utils/helpers'
import Modal from 'react-modal'
import ConfirmPopup from '../../UI/Modals/ConfirmPopup'
import { Tabs } from './Step2'

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 15px;
`

class Step3 extends Component {
  state = {
    confirmOpen: false,
    prevOpen: false,
    nextOpen: false
  }
  // Function that initializes the state for step 3 components
  initializeComponents (packageItem) {
    const currentPackage = packageItem
    // Filter out step 3 items
    const step3Items = currentPackage.items.filter((item) => item.id_step === 3)
    const components = []
    // Default List of selected components
    // Components with the lowest price should be selected by default
    step3Items.map(item => {
      // If Code is 1 - Fixed component
      if (item.display_type_id === 1) {
        components.push({
          name: item.name,
          price: 0,
          net: 0,
          tax: 0,
          type: item.display_type_id,
          selected: true,
          config_bit: item.config_bit,
          id: item.id
        })
        // If item has a variation - Type 2 or Type 3 addable if variant does not have price 0
      } else if (item.variation) {
        // Check if the variation already exists in the component list
        if (_.find(components, { name: item.variation })) {
          // Variation exists - Index of the item in components
          const componentIndex = _.findIndex(components, { name: item.variation })
          const component = _.find(components, { name: item.variation })
          // Check if the current item price being iterated is less than component amount
          // that has been added. If so then replace it
          if (item.amount < component.price) {
            components[componentIndex] = {
              name: item.variation,
              price: item.amount,
              net: getNetPrice(item.amount),
              tax: getTax(item.amount),
              details: item.display_type_id === 2 ? [item.name] : [], // If type 3 then nothing selected
              type: item.display_type_id,
              selected: item.display_type_id === 2, // It's default selected only if type 2
              config_bit: item.config_bit,
              // Item ID is set only if selected so by default
              // type 3 doesn't have any option selected
              id: item.display_type_id === 2 ? item.id : ''
            }
          }
        } else {
          // Variation does not exist, so just add it
          console.log('&&&&&&&&', item.id, ![44, 45].includes(item.id), item.name);
          components.push({
            name: item.variation,
            price: item.amount,
            net: getNetPrice(item.amount),
            tax: getTax(item.amount),
            details: [item.name],
            type: item.display_type_id,

            // selected: true,
            //
            // NEWLY ADDED
            selected: ![44, 45].includes(item.id),

            config_bit: item.config_bit,
            id: item.id
          })
        }
      } else if (item.display_type_id === 3) { // It's of addable type
        components.push({
          name: item.name,
          price: item.amount,
          net: getNetPrice(item.amount),
          tax: getTax(item.amount),
          type: item.display_type_id,
          selected: false,
          config_bit: item.config_bit,
          id: item.id
        })
      } else {
        components.push({
          name: item.name,
          price: item.amount,
          net: getNetPrice(item.amount),
          tax: getTax(item.amount),
          type: item.display_type_id,
          selected: true,
          config_bit: item.config_bit,
          id: item.id
        })
      }
    })
    // Sum of all components price
    const totalPrice = _.reduce(components,
      (sum, component) => component.selected ? sum + component.price : sum,
      0)
    // Data to update in step
    const data = {
      active: true,
      visited: true,
      price: totalPrice,
      net: getNetPrice(totalPrice),
      tax: getTax(totalPrice),
      components
    }

    // Clear options when initialized or when tab changed
    // Blank array is set
    this.props.displayVariations()
    // Update step 3 of the calculator
    this.props.updateCalculator(3, data)
    // Update the list of components
    this.props.updateComponentList(components)
  }

  componentDidMount () {
    const { currentPackage, steps } = this.props
    let data = {
      active: true,
      visited: true
    }
    if (!steps[2].visited) { // Initialize only if visiting first time
      this.initializeComponents(currentPackage)
    } else { // Else update with state already stored
      this.props.updateCalculator(3, data)
      this.props.updateComponentList(steps[2].components)
    }
  }

  openConfirmModal (packageItem) {
    // Set state of the package item being changed
    this.setState({ confirmOpen: true, packageItem })
  }

  closeConfirmModal () {
    this.setState({ confirmOpen: false })
  }

  handleTabChange (packageItem) {
    const price = _.find(packageItem.items, { code: 1 }).amount
    const data = {
      price: price,
      net: getNetPrice(price),
      tax: getTax(price),
      selectedComponent: packageItem.name,
      packageDetails: packageItem
    }
    // Update the calculator for step 2 when package tab is changed
    this.props.updateCalculator(2, data)
    // Reinitialize step 3 components as well
    this.initializeComponents(packageItem)
  }

  openNextStepModal () {
    this.setState({ nextOpen: true })
  }

  closeNextStepModal () {
    this.setState({ nextOpen: false })
  }

  openPrevStepModal () {
    this.setState({ prevOpen: true })
  }

  closePrevStepModal () {
    this.setState({ prevOpen: false })
  }

  handlePrevClick () {
    const { sport } = this.props.match.params // Sport token from URL
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    this.props.history.push(`/noleggia/${sport}/2?variant=${currentVariant}`)
  }

  handleNextClick () {
    const { sport } = this.props.match.params // Sport token from URL
    const currentVariant = qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).variant
    const path = `/noleggia/${sport}/4?variant=${currentVariant}`
    this.props.updateCalculator(4, { path })
    this.props.history.push(path)
  }

  render () {
    const { currentPackage, variant } = this.props
    return (
      <Wrapper>
        <Tabs tabCount={variant.packages.length}>
          {variant.packages.map((packageItem, index) => (
            <Tab
              key={index}
              onClick={this.openConfirmModal.bind(this, packageItem)}
              active={currentPackage.id === packageItem.id}
            >
              PACHETTO {packageItem.name}
            </Tab>
          ))}
        </Tabs>
        <Configurator step={3} />
        <ButtonWrapper>
          <Button
            onClick={this.openPrevStepModal.bind(this)}
            size='small'
          >
            <Caret transform='rotate(180)' fill='#fff' /> &nbsp;&nbsp; STEP PRECEDENTE
          </Button>
          <Button
            onClick={this.openNextStepModal.bind(this)}
            size='small'
          >
            STEP SUCCESSIVO &nbsp;&nbsp; <Caret fill='#fff' />
          </Button>
        </ButtonWrapper>
        <Modal
          isOpen={this.state.confirmOpen}
          className='Modal2'
          overlayClassName='Overlay2'
        >
          <ConfirmPopup
            title='SEI SICURO DI;VOLER SCEGLIERE;UN ALTRO PACCHETTO?'
            closeModal={this.closeConfirmModal.bind(this)} // Close modal
            confirm={this.handleTabChange.bind(this, this.state.packageItem)} // Confirm yes click
          />
        </Modal>

        {/* Prev Step Confirmation Popup */}
        <Modal
          isOpen={this.state.prevOpen}
          className='Modal2'
          overlayClassName='Overlay2'
        >
          <ConfirmPopup
            title='VUOI TORNARE;ALLO STEP PRECEDENTE?'
            closeModal={this.closePrevStepModal.bind(this)}
            confirm={this.handlePrevClick.bind(this)}
          />
        </Modal>

        {/* Next Step Confirmation Popup */}
        <Modal
          isOpen={this.state.nextOpen}
          className='Modal2'
          overlayClassName='Overlay2'
        >
          <ConfirmPopup
            title='VUOI PROSEGUIRE;CON IL PREVENTIVO?'
            closeModal={this.closeNextStepModal.bind(this)}
            confirm={this.handleNextClick.bind(this)}
          />
        </Modal>
      </Wrapper>
    )
  }
}

function mapStateToProps (state) {
  return {
    sports: state.sports.data,
    variant: state.variants.data,
    currentPackage: state.calculator.steps[1].packageDetails,
    components: state.calculator.components,
    steps: state.calculator.steps
  }
}

export default connect(mapStateToProps, { updateCalculator, updateComponentList, displayVariations })(Step3)



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step3.js